// extracted by css-extract-rspack-plugin
export default {"question":"_48a57be1","questionHeader":"_3e9681e","questionTitle":"_e1576341","answerCount":"_5ed754b0","button":"_889b4979"};